import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ModalA11YContext = /*#__PURE__*/createContext(() => {});
const ModalSiblingCountContext = /*#__PURE__*/createContext({
  siblingCount: 0,
  setSiblingCount: () => {}
});
export function useModalA11YContext() {
  return useContext(ModalA11YContext);
}
export function useModalSiblingCountContext() {
  return useContext(ModalSiblingCountContext);
}
export function ModalA11YProvider(props) {
  const [descendantModalOpen, setDescendantModalOpen] = useState(false);
  const [siblingCount, setSiblingCount] = useState(0);
  return /*#__PURE__*/_jsx(ModalA11YContext.Provider, {
    value: setDescendantModalOpen,
    children: /*#__PURE__*/_jsx(ModalSiblingCountContext.Provider, {
      value: {
        siblingCount,
        setSiblingCount
      },
      children: /*#__PURE__*/_jsx("div", {
        "aria-hidden": descendantModalOpen,
        style: {
          height: '100%',
          width: '100%'
        },
        children: props.children
      })
    })
  });
}
//# sourceMappingURL=ModalA11YProvider.js.map